import { offstreetClient } from "../../../../api/client";
import { usePermitFormData } from "../../PermitContextProvider";
import type { PermitTypeDto } from "../../types";

export const usePermitInvoice = ({ permitType }: { permitType: PermitTypeDto }) => {
	const permit = usePermitFormData();
	const precalculatedInvoice = permit.parkingChoiceId
		? permitType.invoices.find((invoice) => invoice.permitTypeId === permit.parkingChoiceId)?.invoice
		: undefined;
	const parkingChoice = permitType.wizardSettings.choices?.find(
		(choice) => choice.permitTypeId === permit.parkingChoiceId,
	);
	const previewInvoiceEnabled = Boolean(
		!precalculatedInvoice &&
			parkingChoice?.payments.enabled &&
			permit.parkingChoiceId &&
			permit.permitIntervals?.length &&
			permit.permitIntervals?.every((interval) => interval.startDateTimeISO && interval.endDateTimeISO),
	);
	const { data: previewInvoiceResult, isPending } =
		offstreetClient.paymentSession.getPermitInvoicePreviewPublic.useQuery(
			{
				parkingChoiceId: permit.parkingChoiceId ?? 0,
				rawIntervals:
					permit.permitIntervals?.flatMap((interval) =>
						interval.startDateTimeISO && interval.endDateTimeISO
							? [
									{
										startDateTimeISO: interval.startDateTimeISO,
										endDateTimeISO: interval.endDateTimeISO,
										schedules: interval.schedules,
									},
								]
							: [],
					) ?? [],
				locationIds: permit.locationIds ?? [],
			},
			{
				enabled: previewInvoiceEnabled,
			},
		);
	return {
		invoice: precalculatedInvoice ?? previewInvoiceResult?.invoice,
		isInvoicePending: previewInvoiceEnabled && isPending,
	};
};
